import { AbstractControl } from '@angular/forms';

export class ObjectValidators {
  static required(control: AbstractControl): { [key: string]: any } {
    return control.value && Object.keys(control.value).length ? null : { required: true };
  }
}
